export const DEFAULT_MAX_LENGTH = 255;

export interface FlowAttachmentFieldCreateRequest {
  idInscriptionFlow: number;

  name: string;

  description: string;

  tooltip: string;

  visible: boolean;

  enabled: boolean;

  required: boolean;

  order: number;
}

export class FlowAttachmentFieldCreateRequestImpl
  implements FlowAttachmentFieldCreateRequest {
  constructor(idFlow: number, order: number) {
    this.idInscriptionFlow = idFlow;
    this.order = order;
  }

  idInscriptionFlow: number;

  name = "Nouveau champ";

  description = "";

  tooltip = "";

  visible = true;

  enabled = true;

  required = false;

  order: number;
}
